export const NO_WELCOME_DIALOG = 'NO_WELCOME_DIALOG_BJ';
export const WELCOME_DIALOG = 'WelcomeDialog';
